import axios from 'axios';
import {
    interceptorsRequest,
    interceptorsRequestError,
    interceptorsResponse,
    interceptorsResponseError,
} from './interceptors';

// Create API instance for v1 endpoints
console.log('APIV1 baseURL:', process.env.REACT_APP_BASE_URL_V1);
let APIV1 = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL_V1,
    responseType: 'json',
});
APIV1.defaults.headers.post['content-type'] = 'application/json';
APIV1.defaults.headers.get['Accept'] = 'application/json';

APIV1.interceptors.request.use(
    (request) => {
        const interceptorsReq = interceptorsRequest(request);
        return interceptorsReq;
    },
    (error) => {
        const promiseError = interceptorsRequestError(error);
        return promiseError;
    }
);

APIV1.interceptors.response.use(
    (response) => {
        // Dispatch that we finished loading.
        const interceptorsRes = interceptorsResponse(response);
        return interceptorsRes;
    },
    (error) => {
        const responseError = interceptorsResponseError(error);
        return responseError;
    }
);

export default APIV1;
